<template>
  <div
    class="flex h-full w-full flex-col items-center justify-center space-y-6 sm:h-40 sm:flex-row sm:space-x-6 sm:space-y-0"
  >
    <div class="flex h-36 w-full items-center space-x-6 sm:h-40">
      <account-info-card-component />
      <investment-info-card-component />
    </div>
    <allocation-info-card-component />
    <iframe
      :src="banner"
      class="hidden h-40 w-full rounded-lg shadow-xl xl:block"
      frameBorder="0"
      id="banner"
    ></iframe>
  </div>
</template>

<script>
import accountInfoCardComponent from "./account-info-card.component.vue";
import AllocationInfoCardComponent from "./allocation-info-card.component.vue";
import InvestmentInfoCardComponent from "./investment-info-card.component.vue";
export default {
  props: {
    banner: {
      type: String,
    },
  },
  components: {
    accountInfoCardComponent,
    InvestmentInfoCardComponent,
    AllocationInfoCardComponent,
  },
};
</script>

<style></style>
, AllocationInfoCardComponent
